import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from '../procedural/SurfaceLineFeature3D'
import React from 'react'
import { GeckoComponentPath, GeckoConeCircumferentialWeld } from 'types'
/**
 * A component used to render a single Circumferential weld on a component's surface
 * @param model             The asset model for this Circumferential weld
 * @constructor
 */
export const ConeCircumferentialWeldFeature3D: React.FC<{
  model: GeckoConeCircumferentialWeld
}> = ({ model }) => {
  const path = React.useMemo(() => {
    return GeckoComponentPath.CreateFromHorizontalLine(model.feature_geometry)
  }, [model.feature_geometry])

  return (
    <>
      <SurfaceLineFeature3D
        path={path}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
    </>
  )
}
